export default __webpack_public_path__ + "static/media/footer-whatsapp-icon.935e7ccc.svg";